module.exports = { "default": require("core-js/library/fn/promise"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/babel-runtime/core-js/promise.js
// module id = 47
// module chunks = 0